import { SurfaceContext } from './SurfaceContext';
import type { SurfaceProviderProps } from './types';

export const SurfaceProvider = ({ children, surface = 'web' }: SurfaceProviderProps) => (
  <SurfaceContext.Provider value={surface}>
    <div data-surface={surface} style={{ display: 'contents' }}>
      {children}
    </div>
  </SurfaceContext.Provider>
);
